export class OptionsRegistry {
    constructor() {
        this.options = new Map();
        this.lazyOptions = new Map();
        this.optionIdsByType = new Map();
        this.optionGroups = new Map();
    }
    registerOption(id, type, optionCreator) {
        this.lazyOptions.set(id, optionCreator);
        this.registerOptionIdWithType(id, type);
    }
    addOption(id, option) {
        this.options.set(id, option);
        this.registerOptionIdWithType(id, option.type.typeRef);
    }
    addOptionGroup(id, optionGroup) {
        this.optionGroups.set(id, optionGroup);
    }
    getOptions() {
        if (this.lazyOptions.size > 0) {
            console.warn('This operation will materialize all lazy options!');
        }
        for (const id of this.lazyOptions.keys()) {
            this.materializeOptionWithId(id);
        }
        return Array.from(this.options.values());
    }
    getOptionGroups() {
        return Array.from(this.optionGroups.values());
    }
    hasOption(id) {
        return this.options.has(id) || this.lazyOptions.has(id);
    }
    hasOptionGroup(id) {
        return this.optionGroups.has(id);
    }
    getOptionById(id) {
        if (typeof id === 'undefined') {
            return undefined;
        }
        if (id === null) {
            return null;
        }
        if (typeof id === 'string') {
            if (this.hasOption(id)) {
                const option = this.options.get(id);
                if (!option) {
                    this.materializeOptionWithId(id);
                }
                return this.options.get(id);
            }
        }
        throw new Error(`Cannot find option ${JSON.stringify(id)}`);
    }
    findOptionsIdsWithType(typeRef) {
        var _a;
        return (_a = this.optionIdsByType.get(typeRef)) !== null && _a !== void 0 ? _a : [];
    }
    findOptionsWithType(typeRef) {
        return this.getOptions().filter(v => v.type.typeRef === typeRef);
    }
    getOptionOrOptionGroupById(id) {
        if (typeof id === 'undefined') {
            return undefined;
        }
        if (id === null) {
            return null;
        }
        if (typeof id === 'string') {
            if (this.hasOption(id)) {
                const option = this.options.get(id);
                if (!option) {
                    this.materializeOptionWithId(id);
                }
                return this.options.get(id);
            }
            if (this.hasOptionGroup(id)) {
                return this.optionGroups.get(id);
            }
        }
        throw new Error(`Cannot find option or option group ${JSON.stringify(id)}`);
    }
    findOptionGroupById(id) {
        return this.optionGroups.get(id);
    }
    materializeOptionWithId(id) {
        const optionCreator = this.lazyOptions.get(id);
        if (optionCreator) {
            this.lazyOptions.delete(id);
            this.options.set(id, optionCreator());
        }
    }
    registerOptionIdWithType(id, type) {
        const ids = this.optionIdsByType.get(type);
        if (ids) {
            ids.push(id);
        }
        else {
            this.optionIdsByType.set(type, [id]);
        }
    }
}
//# sourceMappingURL=OptionsRegistry.js.map